export default function convertToNumber(value, removeComma = false) {
    const parsedValue = parseFloat(removeComma && typeof value === 'string'
        ? value.replace(/,/g, '')
        : value);
    return Number.isNaN(parsedValue) ? -Infinity : parsedValue;
}
